import { render, staticRenderFns } from "./staffallowances.vue?vue&type=template&id=63d39a64"
import script from "./staffallowances.vue?vue&type=script&lang=js"
export * from "./staffallowances.vue?vue&type=script&lang=js"
import style0 from "./staffallowances.vue?vue&type=style&index=0&id=63d39a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports